import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { Section } from '../../../../a11y/headings/tagWrappers';
import Heading from '../../../../a11y/headings/Heading';
import { VisuallyHidden } from '../../../../a11y';
import { useOverlayContext } from '../Overlay/OverlayContext/OverlayContext';
import ErrorBoundary from '../../../../ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../../types/deviation';
import { useTranslation } from 'react-i18next';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import Overlay from '../Overlay';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { getDeviationType } from '../../../_helpers';
import useDeviationDrag from '../../../../Dnd/useDeviationDrag';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import s from './Default.scss';
import overlayHelperStyles from '../OverlayHelpers.scss';
var Default = function (_a) {
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions;
    var t = useTranslation().t;
    var showOverlayTitle = useOverlayContext(deviation).showTitle;
    var _b = useDeviationDrag({
        deviation: deviation,
        width: width,
        height: height,
    }), dragPreview = _b.dragPreview, drag = _b.drag;
    var type = getDeviationType(deviation);
    var isBlockedBySubscription = useSubscriptionTier(deviation).isBlockedBySubscription;
    var linkAsWrapper = type === DeviationTypes.IMAGE;
    var a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    return (React.createElement(React.Fragment, null,
        dragPreview,
        React.createElement(Section, { className: classnames(s['root'], !isBlockedBySubscription && overlayHelperStyles['hoverable'], className), style: __assign({ width: width,
                height: height }, style), "data-hook": BiDataHook.DEVIATION_STD_THUMB, ref: drag },
            React.createElement(ErrorBoundary, null,
                /*
                Because we don't always show a title inside of the overlay,
                we'll place this here to avoid any untitled sections polluting the document outline
              */
                !showOverlayTitle && (React.createElement(VisuallyHidden, null,
                    React.createElement(Heading, null, a11yLabel))),
                linkAsWrapper ? (React.createElement(DeviationLink, { "aria-label": a11yLabel, deviation: deviation },
                    React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive, "aria-hidden": "true" }))) : (React.createElement(React.Fragment, null,
                    React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive, "aria-hidden": "true" }),
                    React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title, "aria-label": a11yLabel },
                        React.createElement("span", null)))),
                React.createElement(Overlay, { deviation: deviation, width: width, height: height, className: s['overlay'], extraActions: extraActions, "aria-hidden": "true" })))));
};
Default.displayName = 'Default';
export default Default;
//# sourceMappingURL=Default.js.map